import React from 'react';
import './Products.css';
import ProductsHero from '../../images/products-hero.jpg';
import Header from "../../Header/Header"
import HeroSection from '../../Components/HeroSection/HeroSection';
import instant from "../../images/gaming/instant-loto.png";
import scratch from "../../images/gaming/scratch.png";
import horse from "../../images/gaming/horse.png";
import numbergame from "../../images/gaming/number.png";
import sports from "../../images/gaming/sport.png";
import module from "../../images/vas/module.jpg";
import portal from "../../images/vas/portal.jpg";
import sms from "../../images/vas/sms.jpg";
import video from "../../images/vas/video.jpg";
import { Container, Row, Col } from 'bootstrap-4-react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Slide from 'react-reveal/Slide';
import transactionalPlatform from "../../images/transactional-platform.jpg";
import reconTools from "../../images/recon-tools.jpg";
import mobileM from "../../images/mobile-m.jpg";
import Footer from '../../Footer/Footer';
import { animateScroll as scroll} from 'react-scroll';
import ReactGA from 'react-ga';

class Products extends React.Component{
    constructor() {
        super();
        this.state = {
            item1:'',
            item2:'active',
            item3:'',
        }
        this.setProduct1 = this.setProduct1.bind(this);
        this.setProduct2 = this.setProduct2.bind(this);
        this.setProduct3 = this.setProduct3.bind(this);
    }
    setProduct1() {
        this.setState({ item1: 'active'});
        this.setState({ item3: ''});
        this.setState({ item2: ''});
        scroll.scrollTo(900, {
            delay: 1000
        });
    }
    setProduct2() {
        this.setState({ item2: 'active'});
        this.setState({ item3: ''});
        this.setState({ item1: ''});
        scroll.scrollTo(900, {
            delay: 1000
        });
    }
    setProduct3() {
        this.setState({ item3: 'active'});
        this.setState({ item2: ''});
        this.setState({ item1: ''});
        scroll.scrollTo(900, {
            delay: 1000
        });
    }
    componentWillMount() {
        window.scrollTo(0, 0);
    }
    componentDidMount() {
        ReactGA.pageview('/products/');
    }
    render() {    
       return (
        <div className="solution-page products-page">
            <Header />
            <HeroSection pageTitle="Solutions" background={ProductsHero} />
            <section className="page-content">
                <Container>
                    <ul className="breadcrumbs">
                        <li><Link to="/">Homepage</Link></li>
                        <li><Link to="/products/" className="current">Products</Link></li>
                    </ul>
                </Container>
                <div className="solution-page-list">
                    <Container className="no-margin">
                        <div className="node-title">
                            <div></div>
                            <i className="fa fa-circle"></i>
                            <span> Products </span>
                            <i className="fa fa-circle"></i>
                            <div></div>
                        </div>
                        <div className="page-description-container">
                            <i className="fa fa-circle"></i>
                            <div className="page-description">
                                <p>
                                    We offer a wide range of gaming and lottery products from instant lottery and numbers games to digital scratch cards plus many more.
                                    </p>
                            </div>
                            <i className="fa fa-circle"></i>
                        </div>
                    </Container>
                </div>
                <div className="products-wrap">
                    <div className={this.state.item2 + " item item-2"} onClick={this.setProduct2}>
                        <div className="gradient-wrapper">
                            <h3>Gaming</h3>
                        </div>
                    </div>
                    <div class={this.state.item1 + " item item-1"} onClick={this.setProduct1}>
                        <div className="gradient-wrapper">
                            <h3>Mobile Financial Services</h3>
                        </div>
                    </div>
                    <div className={this.state.item3 + " item item-3"} onClick={this.setProduct3}>
                        <div className="gradient-wrapper">
                            <h3>Value Added Services</h3>
                        </div>
                    </div>
                </div>
                <Container className={this.state.item1 + " analytics-list products-list mfl"}>
                    <Slide left>
                        <Row className="selected-product">
                            <i className="fa fa-circle"></i>
                            <Col col="md-10 12" offset="md-1">
                                <div className="selected-title">
                                    <h2><i className="fa fa-circle"></i>Mobile Financial Services<i className="fa fa-circle"></i></h2>
                                </div>
                                <p>Mobile money can help boost the population's financial inclusion by providing otherwise unavailable banking services. Mobile financial services are an affordable, secure and convenient way to bring greater access to banking.</p>
                            </Col>
                            <i className="fa fa-circle"></i>
                        </Row>
                    </Slide>
                    <Slide right>
                        <Row>
                        <Col col="md-6 12" offset="md-1" className="text-container left order2">
                            <div className="lines-container">
                                <h3>
                                    <i className="fa fa-circle"></i>
                                    Transactional Platform
                                    <i className="fa fa-circle"></i>
                                </h3>
                            </div>
                            <p>
                                We do what it takes to make it work
                                for
                                our clients and their customers. We can run a multitude of sophisticated models
                                for a potentially unlimited number of customers regardless of the technological environment’ s complexity.
                            </p>
                        </Col>
                        <Col col="md-5 12">
                            <img src={transactionalPlatform}/>
                        </Col>
                    </Row>
                    </Slide>
                    <Slide left>
                        <Row>
                        <Col col="md-5 12" offset="md-1">
                            <img src={mobileM}/>
                        </Col>
                        <Col col="md-6 12" className="text-container right">
                            <h3>Mobile Money</h3>
                            <p>
                               Our technology provides our clients with a comprehensive set of tools to integrate any mobile real-time payment process.We integrate with most MNOs’ mobile wallets, notably MTN, Airtel, Tigo, Vodacom and Orange.
                            </p>
                        </Col>
                    </Row>
                    </Slide>
                    <Slide right>
                        <Row>
                        <Col col="md-6 12" offset="md-1" className="text-container order2">
                            <h3>Reconciliation Tools</h3>
                            <p>
                                We offer a full reconciliation process with complex and heterogeneous platforms.
                            </p>
                        </Col>
                        <Col col="md-5 12">
                            <img src={reconTools}/>
                        </Col>
                    </Row>
                    </Slide>
                </Container>
                <Container className={this.state.item2 + " analytics-list products-list"}>
                    <Slide left>
                        <Row className="selected-product">
                        <i className="fa fa-circle"></i>
                        <Col col="md-10 12" offset="md-1">
                            <div className="selected-title">
                                <h2><i className="fa fa-circle"></i>Gaming<i className="fa fa-circle"></i></h2>
                            </div>
                            <p>
                                We offer state-of-the-art secure mobile and online gaming platforms: a complete solution to fully operate mobile and online lotteries and sports betting in the world’s growth markets.
                                <br/><br/>
                                We can deploy games ranging from the traditional matching 6 numbers in any order between 1–49 and Pick 3 matching 3 numbers in the right order between 1–9 to mobile scratch cards, sports betting and horse racing.
<br/><br/>
                                Your players can play and purchase tickets from his game wallet on USSD, WEB and SMS or directly from Mobile money USSD portal. Our platform and games are highly customizable to integrate your brand and your specific customer requirements.
<br/><br/>
                                Platform: <br/>
                                ·Gaming Studios: games monitoring and administration<br/>
                                · Transaction Platform: player account management, game wallet, transactions, SMS notifications<br/>
                                · Mobile Money Integration<br/>
                                · Real-Time Data Analytics<br/>
                                · Player Profiles Segmentation<br/>
                                · Mobile Marketing Campaigns<br/>
                                · Financial Reconciliation<br/>
                                · Customer Care Helpdesk
                            </p>
                        </Col>
                        <i className="fa fa-circle"></i>
                    </Row>
                    </Slide>
                    <Slide right>
                        <Row>
                        <Col col="md-6 12" offset="md-1" className="text-container left order2">
                            <div className="lines-container">
                                <h3>
                                    <i className="fa fa-circle"></i>
                                    Instant Lottery Games
                                    <i className="fa fa-circle"></i>
                                </h3>
                            </div>
                            <p>
                               These are available on our gaming studio with unlimited number of simple instant draw games. The draw frequency and prize distribution can be easily configured.
                            </p>
                        </Col>
                        <Col col="md-5 12">
                            <img src={instant}/>
                        </Col>
                    </Row>
                    </Slide>
                    <Slide left>
                        <Row>
                        <Col col="md-5 12" offset="md-1">
                            <img src={scratch}/>
                        </Col>
                        <Col col="md-6 12" className="text-container right">
                            <h3>Digital Scratch Cards</h3>
                            <p>
                                These are available on our gaming studio and can be played via USSD or the web.
                            </p>
                        </Col>
                    </Row>
                    </Slide>
                    <Slide right>
                        <Row>
                        <Col col="md-6 12" offset="md-1" className="text-container order2">
                            <h3>Horse Racing</h3>
                            <p>
                                This content is available on our betting studio and can be played online or via USSD. We can filter international horse racing betting by competitions, markets and betting types.
                            </p>
                        </Col>
                        <Col col="md-5 12">
                            <img src={horse}/>
                        </Col>
                    </Row>
                    </Slide>
                    <Slide left>
                        <Row>
                            <Col col="md-5 12" offset="md-1">
                                <img src={numbergame}/>
                            </Col>
                            <Col col="md-6 12" className="text-container right">
                                <h3>Number Games (5/90, pick 3, 4/48)</h3>
                                <p>
                                    These games are available on our gaming studio and can be played online, USSD or SMS. The draw frequency and prize distribution can be easily configured.
                                </p>
                            </Col>
                        </Row>
                    </Slide>
                    <Slide right>
                        <Row>
                            <Col col="md-6 12" offset="md-1" className="text-container order2">
                                <h3>Sports Betting</h3>
                                <p>
                                    Our sports studio manages and optimizes online and USSD sports betting competitions, markets, betting types via the leading sports data providers.
                                </p>
                            </Col>
                            <Col col="md-5 12">
                                <img src={sports}/>
                            </Col>
                        </Row>
                    </Slide>
                </Container>
                <Container className={this.state.item3 + " analytics-list products-list vas"}>
                    <Slide left>
                        <Row className="selected-product">
                            <i className="fa fa-circle"></i>
                            <Col col="md-10 12" offset="md-1">
                                <div className="selected-title">
                                    <h2><i className="fa fa-circle"></i>Value Added Services<i className="fa fa-circle"></i></h2>
                                </div>
                                <p>
                                    We have developed application management systems to publish personalised multimedia and content to mobile subscribers through USSD, online or SMS premium services. Customers pay to access this valued-added exclusive content by a small fee per week. We manage full content delivery through all channels and the customers’ subscription life cycle.
                                    <br/>
                                    Our platform provides: <br/>
                                     ·Content and Applications Studios<br/>
                                     · Subscription Service Manager<br/>
                                     · Payments: Direct Carrier Billing<br/>
                                     · Mobile Online Connect<br/>
                                     · Mobile Marketing Campaigns<br/>
                                     · Subscriber Profiles Segmentation<br/>
                                     · Real-Time Data Analytics
                                
                                </p>
                            </Col>
                            <i className="fa fa-circle"></i>
                        </Row>
                    </Slide>
                    <Slide right>
                        <Row>
                        <Col col="md-6 12" offset="md-1" className="text-container left order2">
                            <div className="lines-container">
                                <h3>
                                    <i className="fa fa-circle"></i>
                                    Information Portals
                                    <i className="fa fa-circle"></i>
                                </h3>
                            </div>
                            <p>
                                We have ready-to-deploy, exclusive and white labelled sports news services
                                for mobile operators to offer to their customers. The features available on all devices via USSD, mobile app and mobile web include sports breaking news, live goal SMS alert, live scores and league positions;
                                all filterable by the customers’ favourite teams
                                for all major sports and competitions worldwide.

                            </p>
                        </Col>
                        <Col col="md-5 12">
                            <img src={portal}/>
                        </Col>
                    </Row>
                    </Slide>
                    <Slide left>
                        <Row>
                            <Col col="md-5 12" offset="md-1">
                                <img src={sms}/>
                            </Col>
                            <Col col="md-6 12" className="text-container right">
                                <h3>SMS Games</h3>
                                <p>
                                    Our clients can launch and monitor instant quizzes and polls with prizes all from a web-based administration interface. We can launch and operate any interactive SMS or USSD applications to communicate with your customers and get immediate access to poll or quiz results.
                                </p>
                            </Col>
                        </Row>
                    </Slide>
                    <Slide right>
                        <Row>
                            <Col col="md-6 12" offset="md-1" className="text-container order2">
                                <h3>Other VAS Products</h3>
                                <p>
                                We have the solution to let you publish and manage many types of content including classified ads, radio-on-demand, directory listings, videos and music which you can immediately monetize through a mobile subscription fee. Our clients can publish and manage online videos with secure mobile authentication and payment options. Customers can view unlimited videos for a weekly fee. If customers connect through mobile internet, they will not be charged for data traffic (i.e. zero-rated). Customers can consume videos without impacting their pre-paid or post-paid data packages
                                </p>
                            </Col>
                            <Col col="md-5 12">
                                <img src={module}/>
                            </Col>
                        </Row>
                    </Slide>
                </Container>
            </section>
            <Footer />
        </div>
       );
    }
}
export default Products;
